module.exports = __webpack_public_path__ + "static/media/0.52a3c976.png";